/*
 * 全局脚本文件
 * @Author: liwenqiang
 * @Date: 2018-03-29 14:13:52
 * @Last Modified by: xiaoming.bai
 * @Last Modified time: 2020-06-29 16:36:36
 */

const $ = require('../jquery')
const Dialog = require('./js/dialog').Dialog
const Cookies = require('js-cookie')
const COOKIE_FAVORITE_KEY = '_favorite'
const COOKIE_LOGIN_STATUS = 'auth_token'
const favoriteTpl = require('./hbs/favoriteTpl.hbs')
const favoriteListTpl = require('./hbs/favoriteListTpl.hbs')

require('./js/web-tracking')

const FavoriteBox = {
  $base: null,
  FavoritesData: null,
  pageIndex: 1,
  pageSize: 3,
  favoriteNum: 0,
  FavoritesDialog: null,
  init: function() {
    var that = this

    var auth_token = Cookies.get(COOKIE_LOGIN_STATUS)

    this.pageIndex = 1

    this.FavoritesDialog = new Dialog({
      className: 'favorites-dialog',
      content: favoriteTpl(),
      padding: 0,
    })

    this.FavoritesDialog.show()

    if (auth_token) {
      $('.upload-cloud')
        .addClass('ed')
        .html('<i class="iconfont icon-yunduan"></i>已同步到云端')
    }

    this.$base = $('.favorites-box')

    this.getFavoriteData()
    // this.FavoritesData = _Compact(_Split(common.getCookie(COOKIE_FAVORITE_KEY) || ''));

    this.$base
      .on('click', '.paging-box .page-item', function(e) {
        var page = $(this).data('page')

        that.pageIndex = +page
        that.render()
      })
      .on('click', '.paging-box .pre', function() {
        var isFirstPage = that.pageIndex === 1
        if (isFirstPage) {
          return
        }

        that.setPrePage()
      })
      .on('click', '.paging-box .next', function() {
        var isLastPage = that.pageIndex >= that.favoriteNum / that.pageSize

        if (isLastPage) {
          return
        }

        that.setNextPage()
      })
      .on('click', '.upload-cloud', function() {
        that.uploadCloud()
      })

    this.$base.on('click', '.list .item .collect', this.unFavorite.bind(this))
  },
  renderPage: function(favoritesData, favoriteNum) {
    if (!favoriteNum) {
      return
    }

    var pagingTpl =
      '<a href="javascript:;" class="pre">' +
      '<i class="iconfont icon-angle-left"></i>' +
      '</a>' +
      '{{#each paging}}' +
      '<a href="javascript:;" data-page="{{index}}" class="{{#unless disabledClick}}page-item {{^}}disabled {{/unless}}{{#if active}}active{{/if}}">{{index}}</a>{{/each}}' +
      '<a href="javascript:;" class="next">' +
      '<i class="iconfont icon-angle-right"></i>' +
      '</a>'
    var compilePaging = handlebars.compile(pagingTpl)

    var pagingArr = []

    var pageSize = Math.ceil(favoriteNum / this.pageSize)

    for (var i = 0, len = pageSize; i < len; i++) {
      var active = false
      if (this.pageIndex - 1 === i) {
        active = true
      }
      var first = 2
      if (pageSize - this.pageIndex < 3) {
        first = first + this.pageIndex - 5
      }
      if (this.pageIndex - i > first + 1 && this.pageIndex > 3) {
        pagingArr.push({ index: '...', active: active, disabledClick: true })
        i = this.pageIndex - first - 2
      } else {
        pagingArr.push({ index: i + 1, active: active })
      }

      var last = 1
      if (this.pageIndex < 3) {
        last = 3 - (this.pageIndex - 1)
      }

      if (i - this.pageIndex >= last && pageSize - this.pageIndex > 2) {
        pagingArr.push({ index: '...', active: active, disabledClick: true })
        i = len
      }
    }

    this.$base.find('.paging-box').html(compilePaging({ paging: pagingArr }))
  },
  setPage: function() {
    var pagingEl = this.$base.find('.paging-box .page-item')
    pagingEl
      .removeClass('active')
      .eq(this.pageIndex - 1)
      .addClass('active')
  },
  renderList: function() {
    var currentList = this.FavoritesData.slice((this.pageIndex - 1) * 3, this.pageIndex * 3)
  },
  setPrePage: function() {
    this.pageIndex--
    this.render()
  },
  setNextPage: function() {
    this.pageIndex++
    this.render()
  },
  render: function() {
    this.setPage()
    this.getFavoriteData()
  },
  uploadCloud: function() {
    var that = this
    var auth_token = Cookies.get(COOKIE_LOGIN_STATUS)
    if (auth_token) {
      return
    }

    var projectIds = Cookies.get(COOKIE_FAVORITE_KEY)

    $.ajax({
      url: '/common/favorite/upload',
      data: { projectIds: projectIds },
    }).then(function(response) {
      if (response.code === 400) {
        return $('.login-btn').trigger('click')
      }

      if (response.code === 0) {
        Cookies.set(COOKIE_FAVORITE_KEY, '')
        that.FavoritesDialog.hide()
        $('#favoriteNum').html(0)
      }
    })
  },
  unFavorite: function(e) {
    var $this = $(e.target)

    var that = this
    var isLogin = Cookies.get(COOKIE_LOGIN_STATUS)
    var projectId = $this.data('projectId')
    var id = $this.data('id')

    if (isLogin) {
      $.ajax({
        url: '/account/follow/unfollow',
        data: { id: id, timestamp: new Date().getTime() },
      }).then(function(result) {
        if (result.code === '0') {
          that.render()
        }
      })
    } else {
      var projectIds = this.getFacoriteProjectIds()

      var currentFavData = _Pull(projectIds, '' + projectId)

      Cookies.set(COOKIE_FAVORITE_KEY, currentFavData.join(','), 183) // 半年过期

      this.render()
    }
  },
  getFavoriteData: function() {
    var that = this
    this.showLoading()
    $.ajax({
      url: '/common/favorite/data',
      data: {
        pageIndex: that.pageIndex,
        pageSize: that.pageSize,
      },
    }).then(function(response) {
      that.hideLoading()

      if (response.rows && response.rows.length === 0 && that.pageIndex > 1) {
        that.pageIndex = 1
        that.render()
      }

      var favoritesData = response.rows || []
      that.favoriteNum = response.dataCount || 0

      that.$base.find('.content .list').html(favoriteListTpl({ rows: favoritesData }))

      $('#dialogFavoriteNum').html(that.favoriteNum)
      $('#favoriteNum').html(that.favoriteNum)
      that.renderPage(favoritesData, that.favoriteNum)
    })
  },
  getFacoriteProjectIds: function() {
    var projectIds = null

    projectIds = _Compact(_Split(Cookies.get(COOKIE_FAVORITE_KEY) || '', ','))

    return projectIds
  },
  showLoading: function() {
    $('.favorite-loading-box').removeClass('hide')
  },
  hideLoading: function() {
    $('.favorite-loading-box').addClass('hide')
  },
}

$(document)
  // 登录
  .on('click', '.login-btn', function() {
    var refer = encodeURIComponent(window.location.href)
    window.location.href = '/passport/login?refer=' + refer
  })
  // 收藏夹
  .on('click', '.favorites-btn', function() {
    FavoriteBox.init()
  })
  // 注销登录
  .on('click', '.logout', function() {
    $.ajax({
      type: 'POST',
      url: '/common/logout',
    }).then(function(data) {
      if (data.code === '0') {
        window.location.reload()
      }
    })
  })
  // 页脚 tab 切换
  .on('mouseenter', '.footer .tab li', function() {
    let index = $(this).index()

    $(this)
      .addClass('active')
      .siblings('li')
      .removeClass('active')

    $(this)
      .parents('.link-box')
      .find('.link-list ul')
      .eq(index)
      .addClass('active')
      .siblings('ul')
      .removeClass('active')
  })

document.addEventListener('scroll', function() {
  const rankEl = document.querySelector('.aside .rank')
  if (!rankEl) return

  const rankElBottom = rankEl.getBoundingClientRect().bottom

  if (rankElBottom <= 90) {
    $('.aside .project').addClass('fixed')
  } else {
    $('.aside .project').removeClass('fixed')
  }
})



//////////////////
// WEBPACK FOOTER
// ./src/global/global.js
// module id = 3
// module chunks = 0 1 2 3